
import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import "../PaymentButton.css";

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("Verifying payment...");
  const [invoice, setInvoice] = useState(null);
  const [redirectToCart, setRedirectToCart] = useState(false);

  // --- Download Invoice Button ---
  const InvoiceButton = ({ uid, invoiceNumber }) => {
    const [loading, setLoading] = useState(false);

    const downloadInvoice = async () => {
      try {
        setLoading(true);
        const res = await fetch(
          `https://agepcoatings.com/payments/invoices/${uid}/${invoiceNumber}`
        );
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          alert(err.error || "Failed to fetch invoice");
          setLoading(false);
          return;
        }
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `invoice-${invoiceNumber}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        setLoading(false);
      } catch (err) {
        console.error(err);
        alert("Error fetching invoice");
        setLoading(false);
      }
    };

    return (
      <button
        onClick={downloadInvoice}
        disabled={loading}
        className="btn btn-success mt-3"
      >
        {loading ? "Loading..." : "Download Invoice"}
      </button>
    );
  };

  useEffect(() => {

  const verifyPayment = async () => {

    try {

      const sessionId = searchParams.get("session_id");

      if (!sessionId) {
        setStatus("❌ Invalid payment redirect");
        return;
      }

      // 🔥 Call Stripe verify API
      const res = await fetch(
        "https://agepcoatings.com/payments/verifyorder_stripe",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            sessionId
          }),
        }
      );

      const data = await res.json();

      console.log("VERIFY RESPONSE:", data);

      if (data.success) {

        setInvoice(data.invoice);

        setStatus("✅ Payment successful!");

      } else {

        setStatus(data.message || "Payment not completed");

        setRedirectToCart(true);

      }

    } catch (err) {

      console.error(err);

      setStatus("❌ Payment verification failed");

      setRedirectToCart(true);

    }

  };

  verifyPayment();

}, [searchParams]);
  useEffect(() => {
    if (redirectToCart) {
      const timer = setTimeout(() => {
        navigate("/addtocart");
      }, 1000); // short delay
      return () => clearTimeout(timer);
    }
  }, [redirectToCart, navigate]);

  useEffect(() => {
    localStorage.removeItem("payload");
  }, []);

  // currency format
  const formatCurrency = (amount, currency) => {
    if (!currency) return amount.toLocaleString(); // fallback if no currency

    try {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency,
        minimumFractionDigits: 2,
      }).format(amount);
    } catch (e) {
      // if invalid currency code, just show number
      return amount.toLocaleString();
    }
  };

  return (
    <div className="container" style={{ marginTop: "12%" }}>
      <h2>Payment Status</h2>
      {status && <p>{status}</p>}

      {invoice && status.includes("successful") && (
        <div className="invoice-box p-4 shadow rounded bg-white">
          {/* Company Header */}
          <div className="text-center mb-4">
            <h2 className="text-primary mb-2 fw-bold">
              AGEP India Private Limited
            </h2>
            <p className="text-muted mb-1">
              C/12, Godavari, Laxmi Industrial Premise, Vartak Nagar, <br />
              Thane, Maharashtra 400606
            </p>
            {/* <h6 className="text-muted mb-3">
              GST No: <span className="fw-semibold">27AASCA4323R1ZZ</span>
            </h6> */}
            {invoice?.courses?.[0]?.currency === "INR" && (
              <h6 className="text-muted mb-3">
                GST No: <span className="fw-semibold">27AASCA4323R1ZZ</span>
              </h6>
            )}

            <h3 className="text-dark text-uppercase fw-bold border-top border-bottom py-2 d-inline-block">
              Sales Receipt
            </h3>
          </div>
          {/* Invoice Number */}
          <p className="mb-3">
            <strong>Invoice Number:</strong> {invoice.invoiceNumber}
          </p>

          {/* Billing Info */}
          <h5 className="mb-2">Bill To:</h5>
          <p className="mb-1">
            <strong>Name:</strong> {invoice.billingDetails?.fullname || "N/A"}
          </p>
          <p className="mb-1">
            <strong>Address:</strong> {invoice.billingDetails?.address || "N/A"}
          </p>
          <p className="mb-1">
            <strong>Email:</strong>{" "}
            {invoice.billingDetails?.email || invoice.email || "N/A"}
          </p>
          {invoice.courses?.[0]?.currency === "INR" && invoice.gst?.number && (
            <p className="mb-3">
              <strong>Customer GST:</strong> {invoice.gst.number}
            </p>
          )}
          {/* Courses Table */}
          <h5>Courses:</h5>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Course</th>
                <th>Level</th>
                <th className="text-end">Amount</th>
              </tr>
            </thead>
            <tbody>
              {invoice.courses?.map((c, idx) => (
                <tr key={idx}>
                  <td>
                    {c.courseTitle || c.courseId}
                    {c.mode === "partial" && (
                      <div className="text-muted small">
                        Course Reservation Fee
                      </div>
                    )}
                  </td>
                  <td> {c.levelId} </td>
                  {/* <td className="text-end">
                    {c.currency} {c.paid === 0 ? c.rate : c.paid}
                  </td> */}
                  <td className="text-end">
                    {formatCurrency(c.paid === 0 ? c.rate : c.paid, c.currency)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {/* Totals Section */}
          <div className="d-flex justify-content-end mt-3">
            <table className="table table-sm w-50 text-end">
              <tbody>
                {/* <tr>
                  <td>
                    <strong>Total in:</strong>
                  </td>
                  <td>
                    {invoice.courses?.[0]?.currency || "INR"}
                    {(invoice.totalAmount || 0) - invoice.gst?.amount}
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>GST in:</strong>
                  </td>
                  <td>
                    {invoice.courses?.[0]?.currency || "INR"} {invoice.gst?.amount || 0}
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Grand Total in: </strong>
                  </td>
                  <td>
                      {invoice.courses?.[0]?.currency || "INR"} 
                      {invoice.totalAmount || 0}
                  </td>
                </tr> */}
                <tr>
                  <td>
                    <strong>Total in:</strong>
                  </td>
                  <td>
                    {formatCurrency(
                      (invoice.totalAmount || 0) - (invoice.gst?.amount || 0),
                      invoice.courses?.[0]?.currency
                    )}
                  </td>
                </tr>

                {/* <tr>
                  <td>
                    <strong>GST in</strong>
                  </td>
                  <td>
                    {formatCurrency(
                      invoice.gst?.amount || 0,
                      invoice.courses?.[0]?.currency
                    )}
                  </td>
                </tr>

                <tr>
                  <td>
                    <strong>Grand Total in:</strong>
                  </td>
                  <td>
                    {formatCurrency(
                      invoice.totalAmount || 0,
                      invoice.courses?.[0]?.currency
                    )}
                  </td>
                </tr> */}
                {/* GST visible only for INR */}
                {invoice.courses?.[0]?.currency === "INR" && (
                  <>
                    <tr>
                      <td>
                        <strong>GST in:</strong>
                      </td>
                      <td>
                        {formatCurrency(
                          invoice.gst?.amount || 0,
                          invoice.courses?.[0]?.currency
                        )}
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <strong>Grand Total in:</strong>
                      </td>
                      <td>
                        {formatCurrency(
                          invoice.totalAmount || 0,
                          invoice.courses?.[0]?.currency
                        )}
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
            </table>
          </div>
          {/* Invoice Button */}
          <div className="text-center mt-3">
            <InvoiceButton
              uid={invoice.uid}
              invoiceNumber={invoice.invoiceNumber}
            />
          </div>
          <hr />
          <p className="text-center">Thank you for your payment!</p>
          <p className="text-center">
            For queries, contact: info.eac-international.com
          </p>
        </div>
      )}
    </div>
  );
}
